import { render } from "./InstigatorUpdate.vue?vue&type=template&id=01c9b2ae&ts=true"
import script from "./InstigatorUpdate.vue?vue&type=script&lang=ts"
export * from "./InstigatorUpdate.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__